import { render } from "./Chip.vue?vue&type=template&id=458aab62&scoped=true"
import script from "./Chip.vue?vue&type=script&lang=js"
export * from "./Chip.vue?vue&type=script&lang=js"

import "./Chip.vue?vue&type=style&index=0&id=458aab62&lang=scss&scoped=true"

import exportComponent from "/var/www/briskly/brskl/products/business/app.prod.new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458aab62"]])

export default __exports__